import { render, staticRenderFns } from "./workStandardPopUp.vue?vue&type=template&id=0aff2d11"
import script from "./workStandardPopUp.vue?vue&type=script&lang=js"
export * from "./workStandardPopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aff2d11')) {
      api.createRecord('0aff2d11', component.options)
    } else {
      api.reload('0aff2d11', component.options)
    }
    module.hot.accept("./workStandardPopUp.vue?vue&type=template&id=0aff2d11", function () {
      api.rerender('0aff2d11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/sws/workStandardPopUp.vue"
export default component.exports